import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';

import Container from 'components/Container';
import { ImageFormatContext } from 'contexts/ImageFormatContext';
import IncutPromoBlock from 'components/IncutPromoBlock';
import SectionLayout, { Element } from 'components/SectionLayout';
import Preloader from 'components/Preloader';
import Layout from 'components/Layout';

import CommonPropTypes from 'utils/propTypes/common';
import EntitiesPropTypes from 'utils/propTypes/entities';

import ActualPromoBlocks from './components/ActualPromoBlocks';
import Catalog from './components/Catalog';
// import Thematics from './components/Thematics';
import Compilations from './components/Compilations';
import RecommendationsBlock from './components/RecommendationsBlock';
import SubscribeBlock from './components/SubscribeBlock';
import Reviews from './components/Reviews';
import StreamingPlatforms from './components/StreamingPlatforms';

const Live = ({
	hotBroadcast,
	incutPromoBlock,
	bottomPromoBlock,
	reviewsPublications,
	reviewsPromoBlocks,
	rubric,
	compilations,
	streamingPlatforms,
	broadcasts,
	recommendations
}) => {
	const imageFormat = useContext(ImageFormatContext);
	const preloadImageSrc =
		!_.isEmpty(hotBroadcast) &&
		getImageUrl(hotBroadcast[0].thumbnailFile, {
			format: imageFormat,
			params: { width: 1366, height: 441 }
		});

	return (
		<Layout
			rubric={rubric}
			rubricPath={rubric.path}
			preloadImageSrc={preloadImageSrc}
		>
			<SectionLayout>
				{!_.isEmpty(hotBroadcast) ? (
					<RecommendationsBlock
						key="HotBroadcastBlock"
						recommendations={hotBroadcast}
						personalRecommendations={recommendations}
					/>
				) : (
					<Preloader key="HotBroadcastPreloader" height="65vh" />
				)}

				{!_.isEmpty(incutPromoBlock) && (
					<Container>
						<IncutPromoBlock theme="rounded" {...incutPromoBlock[0]} />
					</Container>
				)}
				{!_.isEmpty(broadcasts) && (
					<Element key="Catalog" negative="spacingBottom">
						<Catalog broadcast={broadcasts} />
					</Element>
				)}
				<SubscribeBlock key="SubscribeBlock" />
				<Compilations key="CompilationsBlock" compilations={compilations} />
				{!(_.isEmpty(reviewsPublications) || _.isEmpty(reviewsPromoBlocks)) && (
					<Reviews
						key="reviews"
						publications={reviewsPublications}
						promoBlocks={reviewsPromoBlocks}
					/>
				)}
				{/* <Thematics key="BroadcastTypesBlock" /> */}
				<StreamingPlatforms
					key="StreamingPlatforms"
					streamingPlatforms={streamingPlatforms}
				/>
				{!_.isEmpty(bottomPromoBlock) && (
					<ActualPromoBlocks
						key="ActualPromoBlocks"
						promoBlocks={bottomPromoBlock}
					/>
				)}
			</SectionLayout>
		</Layout>
	);
};

Live.propTypes = {
	rubric: CommonPropTypes.rubric,
	hotBroadcast: CommonPropTypes.block.isRequired,
	incutPromoBlock: CommonPropTypes.block,
	bottomPromoBlock: CommonPropTypes.block,
	reviewsPublications: CommonPropTypes.block,
	reviewsPromoBlocks: CommonPropTypes.block,
	streamingPlatforms: PropTypes.objectOf(CommonPropTypes.entities).isRequired,
	compilations: CommonPropTypes.compilations.isRequired,
	broadcasts: EntitiesPropTypes.broadcast,
	recommendations: CommonPropTypes.entities
};

export default Live;
